<template>
    <v-dialog v-model="dialog"
              @click:outside="closeDialog"
              max-width="1000px"
              scrollable
    >
        <v-card>
            <v-toolbar dense :elevation="0">
                <v-toolbar-title class="text-primary-700">
                  My Properties - Add Me - Tenant
                </v-toolbar-title>
                <div class="flex-grow-1"></div>
                <v-btn style="width: 35px; height: 35px" icon @click="closeDialog">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-4">
              <v-stepper v-model="step" vertical :elevation="0" class="rpd-stepper pb-0" style="margin: auto; max-width: 1000px;">
                <v-stepper-step editable step="1" :complete="step > 1" class="pb-4 pt-4">
                  Select Contact Type <strong v-if="contactTypeText">{{ contactTypeText }}</strong> <br/>
                  <!-- small text -->
                  <small v-if="step == 1">Select whether you would like to be added as a Tenant or Tenants Agent</small>
                </v-stepper-step>
                <v-stepper-content step="1">
                  <v-btn depressed color="primary" @click="() => selectContactType('tenant')">Tenant contact</v-btn>
                  <v-btn depressed class="ml-2" color="primary" @click="() => selectContactType('tenant_agent')">Tenants agent</v-btn>
                </v-stepper-content>

                <v-stepper-step :editable="editable" step="2" :complete="step > 2" class="pt-4">
                  Select Tenant <strong v-if="tenantFilter">{{ tenantFilter.name }}</strong>
                  <small v-if="step == 2">Select the Tenant that you would like to be added as the contact for. You can choose which stores in the final step.</small>
                </v-stepper-step>
                <v-stepper-content step="2">
                  <v-row>
                    <v-col cols="auto">
                      <div class="mt-4">For properties where</div>
                    </v-col>
                    <v-col cols="auto">
                      <v-autocomplete
                        v-model="tenantFilter"
                        :loading="tenants.loading"
                        :items="tenants.items"
                        :search-input.sync="tenants.search"
                        cache-items
                        flat
                        hide-no-data
                        clearable
                        return-object
                        item-text="name"
                        item-value="id"
                        label="Tenant"
                        class="ma-0"
                        @change="getProperties"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="auto">
                      <div class="mt-4">is a tenant.</div>
                    </v-col>
                  </v-row>
                  <v-btn depressed color="primary" @click="step = 3">Continue</v-btn>
                </v-stepper-content>

                <v-stepper-step step="3" :editable="editable" class="pt-4">
                  Select Properties <strong v-if="selectedProperties.length">({{ selectedProperties.length }})</strong>
                  <small  v-if="step == 3">The table below shows all stores in RPD for the selected Tenant. Use the Map Search feature or click on the properties in the table for the stores that you would like to be added as a contact. If you would like to be added to all - you can do this quickly using the Map Search feature. </small>
                </v-stepper-step>
                <v-stepper-content step="3">

                  <v-row justify="space-between" class="mt-2">
                    <v-col cols="auto">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn depressed :disabled="tenantFilter == null" color="primary" class="mr-2" v-on="on" @click="searchMap">
                            <v-icon>mdi-map-search</v-icon>
                            Map Search
                          </v-btn>
                        </template>
                        <span> Draw an area on the map to quickly and easily select your properties. Create the area by simply clicking on the map to add the boundaries.</span>
                      </v-tooltip>
                      <!-- <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn color="primary" v-on="on" >
                            <v-icon>mdi-plus</v-icon>
                            Add All
                          </v-btn>
                        </template>
                        <span>Add all properties to the list</span>
                      </v-tooltip> -->
                    </v-col>
                    <v-col cols="auto">
                      <v-text-field
                        v-model="propertiesSearch"
                        append-icon="mdi-table-search"
                        label="Search"
                        single-line
                        hide-details
                        outlined dense
                        @input="getProperties"
                        class="ma-0 pa-0"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-data-table class="mt-4"
                                style="border: 1px solid #e0e0e0; border-radius: 4px;"
                                :headers="propertyHeaders"
                                :items="properties.items"
                                :options.sync="properties.pagination"
                                :loading="properties.loading"
                                :server-items-length="properties.totalRecords"
                                :items-per-page.sync="properties.itemsPerPage"
                                :sort-by.sync="properties.sortBy"
                                :sort-desc.sync="properties.sortDesc"
                                :page.sync="properties.page"
                  >
                    <template v-slot:body="{ items }">
                      <tbody v-if="items.length">
                        <tr v-for="item in items" :key="item.id">
                          <td><a @click="() => showEditProperty(item.id)">{{ item.building_num }}</a></td>
                          <td><a @click="() => showEditScheme(item.scheme.data.id)">{{ item.scheme.data.name }}</a></td>
                          <td>{{ item.address.data.full_address }}</td>
                          <td>
                            <v-btn v-if="checkSelected(item)" style="width:120px" height="40" outlined color="primary" @click="() => selectProperty(item)">
                              <v-icon class="mr-1">mdi-plus</v-icon>
                              <span>Add</span>
                            </v-btn>
                            <v-btn v-else height="40" style="width:120px" outlined color="red" @click="() => unSelectProperty(item)">
                              <v-icon class="mr-1">mdi-close</v-icon>
                              <span>Remove</span>
                            </v-btn>
                          </td>
                        </tr>
                      </tbody>
                      <tbody v-else>
                        <tr>
                          <td colspan="4" class="text-center">No properties found</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-data-table>
                  <!-- <v-row v-if="selectedProperties.length">
                    <v-col>
                      <h3>Selected Properties</h3>
                      <v-list>
                        <v-list-item v-for="property in selectedProperties" :key="property.id">
                          <v-list-item-content>
                            <v-list-item-title>{{ property.building_num? property.building_num + ',' : '' }} {{ property.scheme.data.name }}</v-list-item-title>
                            <v-list-item-subtitle>{{ property.address.data.full_address }}</v-list-item-subtitle>
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-btn icon @click="() => unSelectProperty(property)">
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </v-list-item-action>
                        </v-list-item>
                      </v-list>
                    </v-col>
                  </v-row> -->
                  <v-btn depressed class="mt-5" :disabled="!isCanBeSubmitted" color="primary" @click="submit">Finish</v-btn>
                </v-stepper-content>
              </v-stepper>
            </v-card-text>
            <edit-property-dialog ref="editPropertyDialog"></edit-property-dialog>
            <edit-scheme-dialog ref="editSchemeDialog"></edit-scheme-dialog>
            <select-properties-map-dialog ref="selectPropertiesMapDialog" @submitted="selectProperties"></select-properties-map-dialog>
            <!-- <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn depressed @click="closeDialog">Cancel</v-btn>
                <v-btn depressed :loading="loading"  color="primary" @click="submit">Save</v-btn>
            </v-card-actions> -->
        </v-card>
    </v-dialog>
</template>
<script>

import EditPropertyDialog from "@/components/properties/editPropertyDialog";
import EditSchemeDialog from "@/components/schemes/editSchemeDialog.vue";
import SelectPropertiesMapDialog from "@/pages/myProperties/SelectPropertiesMapDialog.vue";

export default {
  components: {SelectPropertiesMapDialog, EditSchemeDialog, EditPropertyDialog},
  directives: {
  },
  data: () => ({
    dialog: false,
    step: 1,
    tenantFilter: null,
    propertiesSearch: '',
    tenants: {
      loading: false,
      items: [],
      search: '',
    },
    propertyHeaders: [
      { text: 'Unit', value: 'building_num', class:'data-table__cell' },
      { text: 'Scheme', value: 'scheme.data.name', class:'data-table__cell' },
      { text: 'Address', value: 'address', class:'data-table__cell' },
      { text: '', value: 'actions', sortable: false },
    ],

    contactType: null,
    properties: {
      pagination: {},
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
      page: 1,
      totalRecords: 0,
      loading: false,
      items: [],
    },
    selectedProperties: [],
  }),
  watch: {
    'tenants.search'() {
      this.getTenants()
    },
    'properties.pagination': {
      handler() {
        this.getProperties()
      },
      deep: true
    },
  },
  computed: {
    contactTypeText() {
      switch (this.contactType) {
        case 'tenant':
          return 'Tenant contact'
        case 'tenant_agent':
          return 'Tenants agent'
        default:
          return ''
      }
    },
    isCanBeSubmitted() {
      return this.selectedProperties.length && this.contactType
    },
    editable() {
      if(this.contactType){
        return true
      }else{
        return false
      }
    }
  },
  methods: {
    openDialog() {
      this.dialog = true
    },
    closeDialog() {
      this.dialog = false
    },

    clearForm() {
      this.step = 1
      this.tenantFilter = null
      this.propertiesSearch = ''
      this.selectedProperties = []
    },

    showEditProperty(id) {
      this.$refs.editPropertyDialog.showDialog(id);
    },
    showEditScheme(id) {
      this.$refs.editSchemeDialog.showDialog(id);
    },
    async getTenants() {
      const response = await this.$http.get('/companies/', {
        params: {
          q: this.tenants.search,
          per_page: 100,
        }
      });

      this.tenants.items = response.data.data
    },
    selectContactType(type) {
      this.contactType = type
      this.step = 2
    },
    async submit() {
      const formData = {
        contact_type: this.contactType,
        property_ids: this.selectedProperties.map(p => p.id),
      };
      await this.$http.post(`/contacts/add-me`, formData).then(() => {
        this.$emit('submitted')
        this.clearForm()
        this.closeDialog()
      })
      
    },
    searchMap() {
      this.$refs.selectPropertiesMapDialog.showDialog(this.tenantFilter.id)
    },
    async getProperties() {
      this.properties.loading = true;
      const response = await this.$http.get('/properties', {
        params: {
          q: this.propertiesSearch,
          include: 'address,scheme',
          tenant_id: this.tenantFilter ? this.tenantFilter.id : null,
          page: this.properties.pagination.page,
          sort_by: this.properties.pagination.sortBy.length ? this.properties.pagination.sortBy[0] : null,
          desc: this.properties.pagination.sortDesc.length ? (this.properties.pagination.sortDesc[0] ? 1 : 0) : null,
          per_page: this.properties.pagination.itemsPerPage,
          // hide_ids: this.selectedProperties.map(p => p.id),
        }
      });
      this.properties.loading = false;
      const pagination = response.data.meta.pagination
      this.properties.totalRecords = pagination.total
      this.properties.items = response.data.data
    },
    async addAllProperties (){

    },

    checkSelected(item){
      if(this.selectedProperties.some(p => p.id === item.id)){
        return false
      }else{
        return true
      }
    },

    selectProperties(properties) {
      // for property in property, run selectProperty method
      properties.forEach(property => this.selectProperty(property))


    },
    selectProperty(property) {
      this.selectedProperties.push(property)
      // this.properties.items = this.properties.items.filter(p => p.id !== property.id)
    },
    unSelectProperty(property) {
      this.selectedProperties = this.selectedProperties.filter(p => p.id !== property.id)
      // this.properties.items.push(property)
    },
  }
}
</script>